import { Box, Stack, Text } from "@chakra-ui/react";
import { memo } from "react";
import { QuestionHelper } from "../Data";

const QuestionCardAdmin = memo(function QuestionCard({ question, children }) {
  const { code, description, helper } = question;

  return (
    <Box
      p="6"
      bg="white"
      border="2px solid #EAEEF0"
      borderRadius="12px"
      mt={["12px", "0"]}
      pos="relative"
    >
      <Stack spacing="6">
        <div>
          {/* {is_required && ( */}
          <Text
            as="span"
            color="orange.100"
            fontSize="12px"
            lineHeight="24px"
            fontWeight={500}
          >
            Pergunta obrigatória*
          </Text>

          <Text lineHeight="32px" mt="4px" maxW="90%">
            <b>{code}</b> -{" "}
            <Text
              as="span"
              fontWeight={500}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Text>
        </div>

        <QuestionHelper
          description={helper?.description || ""}
          videoUrl={helper?.url_video}
        />
      </Stack>
      {children}
    </Box>
  );
});

export default QuestionCardAdmin;
